// eslint-disable-next-line @typescript-eslint/no-empty-interface, prettier/prettier


// ============================== Styles ==============================

var genBaseStyle = function genBaseStyle(token) {
  var _antTag, _ref;
  return _ref = {}, _ref['.ant-tag'] = (_antTag = {
    height: '28px',
    display: 'inline-flex',
    alignItems: 'center'
  }, _antTag["&-checkable"] = {
    backgroundColor: token.tagDefaultBg,
    // '&:active': {
    //   backgroundColor: token.colorFillSecondary,
    // },

    '&-checked': {
      backgroundColor: token.colorPrimary,
      '&:hover': {
        backgroundColor: token.colorPrimary
      }
    },
    '&[disabled]': {
      backgroundColor: token.tagDisabledBg,
      color: token.tagDisabledColor
    },
    '&:not(.ant-tag-checkable-checked):hover': {
      backgroundColor: token.colorFillSecondary
      // borderColor: token.colorTextQuaternary,
    }
  }, _antTag), _ref['.ant-tag.ant-tag-lg'] = {
    height: '32px'
  }, _ref['.ant-tag.ant-tag-sm'] = {
    height: '24px'
  }, _ref['.ant-tag.ant-tag-success'] = {
    backgroundColor: token.colorSuccess,
    color: token.colorWhite
  }, _ref['.ant-tag.ant-tag-warning'] = {
    backgroundColor: token.colorWarning,
    color: token.colorWhite
  }, _ref['.ant-tag.ant-tag-error'] = {
    backgroundColor: token.colorError,
    color: token.colorWhite
  }, _ref['.ant-tag.ant-tag-processing'] = {
    backgroundColor: token.colorSuccess,
    color: token.colorWhite
  }, _ref;
};

// ============================== Export ==============================
var tagStyleFn = function tagStyleFn(token) {
  // 整体逻辑与antd 保持一致
  // tagDefaultBg/tagDefaultColor 取theme/componentToken/tag

  return [genBaseStyle(token)];
};

export { tagStyleFn };
